import React from 'react'
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import './_card.scss'
import imageUrlBuilder from '@sanity/image-url'
import sanityClient from '../../../client.js'

const builder = imageUrlBuilder(sanityClient)

function urlFor(source) {
  return builder.image(source)
}
function Card({data}) {
  return (
      <>
        {
            data.released  && (
                <div className='cardHome'>
                    {
                        data.mainImage && (
                            <div className="cardHome-iconWrap">
                                <div className="cardHome-iconWrap_icon">
                                    <img src={urlFor(data.mainImage)} style={data.icon ? null : {width: '15px', color: '#697386', objectFit: 'contain'}}/>
                                </div>
                            </div>
                        )
                    }
                    
                    <div className="cardHome-text">
                        <p className="cardHome-text_title">
                            {data.title}
                        </p>
                        <p className='cardHome-text_description'>
                            {data.body}
                        </p>
                    </div>
                    <div className="cardHome-button" onClick={() => window.open(`${data.link}`)}>
                        <p className="cardHome-button_label">
                            {data.buttonLabel ? data.buttonLabel : 'Scopri di più'}
                        </p>
                        <ArrowForwardIos />
                    </div>
                </div>
            )
        }
    
      </>
  )
}

export default Card